import { render } from "./ShareSocialMedia.vue?vue&type=template&id=65775f58"
import script from "./ShareSocialMedia.vue?vue&type=script&lang=js"
export * from "./ShareSocialMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__